import { QueryStringInput } from '@hello-aria/query-string'
import { Repayment, RepaymentGateway } from '../../../shared/models/repaymentModel'
import { resolveApiUrl } from '../../../shared/utils/requestsUtils'
import { RequestResponse, requestService } from '../../../shared/services/requestServices'
import { isNil } from 'lodash'
import { handlePrivateEndpointCompanyFilter, handleHttpError } from '../../../shared/utils/queryUtils'
import { mapSort } from '@/shared/utils/sortUtils'
import { mapRepayment } from '@/shared/utils/repaymentUtils'

export const getRepaymentsService = async (
    companyId: string,
    query?: QueryStringInput,
    signal?: AbortSignal
): Promise<RequestResponse<Repayment[]> | undefined> => {
    try {
        const updatedQuery = handlePrivateEndpointCompanyFilter(companyId, query)

        const url = resolveApiUrl('repayments.getAll', {
            query: {
                ...updatedQuery,
                sorts: mapSort(updatedQuery?.sorts, {
                    usage: 'api'
                })
            },
            variables: { companyId }
        })

        const response = await requestService<RepaymentGateway[]>(url, signal ? { signal } : undefined)

        const mappedResponse = response?.body?.map(mapRepayment)
        return { ...response, body: mappedResponse }
    } catch (error) {
        handleHttpError('getRepaymentsService', error)
    }
}

export const getRepaymentByIdService = async (
    companyId: string,
    id: string | undefined
): Promise<RequestResponse<Repayment> | undefined> => {
    if (isNil(id)) return

    try {
        const url = resolveApiUrl('repayments.get', {
            variables: { companyId, repaymentId: id }
        })
        const response = await requestService<RepaymentGateway>(url)
        return { ...response, body: response?.body ? mapRepayment(response.body) : undefined }
    } catch (error) {
        handleHttpError('getRepaymentByIdService', error)
    }
}
